export const trigger = (data) => {
  if (window.LIFE_CYCLE_EVENT_BUS?.trigger) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('packages-mini.title-click', data);
  }
};
